import type { AIServerName } from '../interfaces';

export default function getAIRootURL(serverName: AIServerName): string {
  const hostnameWithoutSubdomain = window.location.hostname.split('.').slice(-2).join('.');
  return `https://${serverName}.${hostnameWithoutSubdomain}`;
}
